import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import AppRouter from './Router';
// Hide loading screen when React is ready
const hideLoadingScreen = () => {
    if (window.hideLoadingScreen) {
        window.hideLoadingScreen();
    }
};
// Get room configuration from server
const config = window.gridchatConfig || {
    roomId: 'default',
    roomName: 'GridChat',
    isDefaultRoom: true
};
console.log('ðŸš€ GridChat starting with Router...');
console.log('ðŸ“Š Config:', config);
// CRITICAL: Use 'root' to match server HTML
const container = document.getElementById('root');
if (!container) {
    console.error('âŒ Could not find root element. Make sure there is a <div id="root"></div> in your HTML.');
    throw new Error('Root element not found');
}
const root = createRoot(container);
// StrictMode disabled to prevent MediaSoup double-initialization
// WRAPPED WITH AuthProvider
root.render(_jsx(AuthProvider, { children: _jsx(AppRouter, {}) }));
// Hide loading screen after React renders
setTimeout(hideLoadingScreen, 1000);
